import { BUSINESS_NOTICE_30, BUSINESS_NOTICE_30_URL, BUSINESS_NOTICE_65, BUSINESS_NOTICE_65_URL, BUSINESS_NOTICE_95, BUSINESS_NOTICE_95_URL, BUSINESS_NOTICE_120, BUSINESS_NOTICE_120_URL } from './constants';

export const filterTiles = (tileItems: any, filter: string) => tileItems.filter(tile => (tile.product?.metadata?.category ?? true) === filter);

export const getExternalURL = (name: string) => {
  switch (name) {
    case BUSINESS_NOTICE_30:
      return BUSINESS_NOTICE_30_URL;
    case BUSINESS_NOTICE_65:
      return BUSINESS_NOTICE_65_URL;
    case BUSINESS_NOTICE_95:
      return BUSINESS_NOTICE_95_URL;
    case BUSINESS_NOTICE_120:
      return BUSINESS_NOTICE_120_URL;
    default:
      return null;
  }
};

export const isDayNoticeAccount = (name: string) => name === BUSINESS_NOTICE_30 || name === BUSINESS_NOTICE_65 || name === BUSINESS_NOTICE_95 || name === BUSINESS_NOTICE_120;
